import { gql } from '@apollo/client'
import { ProductDetailsSourceProduct } from 'ts/interfaces/productsDetails.interface'

export const GET_EDIT_PAGE_DETAILS = gql`
  query GetEditPageDetails($dealId: Int!, $currentUserEmail: String) {
    editPageDetails(dealId: $dealId, currentUserEmail: $currentUserEmail) {
      errorMessage
      isSuccess
    }
  }
`

export const GET_CACHE_EDIT_PAGE_DETAILS = gql`
  query GetCacheEditPageDetails($dealId: Int!) {
    cacheEditPageDetails(dealId: $dealId) {
      errorMessage
      isSuccess
      dealHeaderInformation {
        isoCurrencyCode
        __typename
      }
      wrappedCombinedFlatProducts {
        isModified
        product {
          lineNumber
          lineTypeCode
          productGenericNumberText
          productGenericDescriptionText
          assosiatePlCode
          estimatedQuantity
          totalDiscountRequestPercentage
          totalDiscountRequestPercentageUpdated
          extendedRequestBdNet
          requestBdNetPriceAmount
          requestBdNetPriceAmountUpdated
          requestNetMarginPercentage
          requestNetMarginPercentageUpdated
          authBdnetPriceAmount
          authBdnetPriceAmountUpdated
          authNetMarginPercentage
          authNetMarginPercentageUpdated
          totalDiscountAuthPercentage
          totalDiscountAuthPercentageUpdated
          guidanceExpertPercentage
          guidanceFloorPercentage
          guidanceTypicalPercentage
          calcGuidanceFloorPercentage
          calcGuidanceExpertPercentage
          calcGuidanceTypicalPercentage
          historicalMedianDiscountPercentage
          historicalBottom25DiscountPercentage
          historicalTop25DiscountPercentage
          authStatus
          isAllLine
          isMyLine
          isOpenLine
          isCostAvailable
          __typename
        }
        __typename
      }
      wrappedPLTotalDynamicResponse {
        totalNetRevenue
        totalDiscountPercentage
        totalOGMPercentage
        plTotalDynamicWrapped {
          isModified
          productLineCode
          plDescription
          isMyLine
          isOpenLine
          isCostAvailable
          estimatedPnBdNetRevenue
          estimatedDiscountPercentage
          estimatedDiscountPercentageUpdated
          netMarginPercentage
          busGroupCode
          plCategoryCd
          expertDiscountPercentage
          floorDiscountPercentage
          typicalDiscountPercentage
          updatedCm
          cm
          __typename
        }
        __typename
      }
      dealCubeHistoryProductDetails {
        dealCubeHistoryDetails {
          dealId
          level
          approversByLevel {
            roleTitle
            decisionReasonCode
            __typename
          }
          productDetails {
            lineNumber
            itemNumber
            scaleId
            netMarginPercentage
            totalDiscountPercentage
            bdNet
            bdNetInDealCurrency
            __typename
          }
          productlineDetails {
            productLineCode
            netMarginPercentage
            estimatedDiscountPercentage
            netRevenue
            __typename
          }
          __typename
        }
        __typename
      }
      totalBdNetPriceAmount
      totalEstimatedQuantity
    }
  }
`

export interface EditPageDetailsResponse {
  editPageDetails: {
    errorMessage: string | null
    isSuccess: boolean
  }
}

export interface EditPageDetailsVariables {
  dealId: number
  currentUserEmail?: string
}

export interface GetCacheEditPageDetailsVariables {
  dealId: number
}

export interface GetCacheEditPageDetailsResponse {
  cacheEditPageDetails: {
    errorMessage: string | null
    isSuccess: boolean
    dealHeaderInformation: {
      isoCurrencyCode: string
    }
    wrappedCombinedFlatProducts: Array<{
      isModified: boolean
      product: ProductDetailsSourceProduct
    }>
    wrappedPLTotalDynamicResponse: {
      totalNetRevenue: number
      totalDiscountPercentage: number
      totalOGMPercentage: number
      plTotalDynamicWrapped: Array<{
        isModified: boolean
        productLineCode: string
        plDescription: string | null
        isMyLine: boolean | null
        isOpenLine: boolean | null
        isCostAvailable: boolean | null
        estimatedPnBdNetRevenue: number | null
        estimatedDiscountPercentage: number
        estimatedDiscountPercentageUpdated: number | null
        totalDiscountAuthPercentage?: number | null
        totalDiscountAuthPercentageUpdated?: number | null
        netMarginPercentage: number
        authNetMarginPercentage?: number | null
        authNetMarginPercentageUpdated?: number | null
        busGroupCode: string | null
        plCategoryCd: string | null
        expertDiscountPercentage: number | null
        floorDiscountPercentage: number | null
        typicalDiscountPercentage: number | null
        updatedCm: number | null
        cm: number | null
      }>
    } | null
    dealCubeHistoryProductDetails: {
      dealCubeHistoryDetails: Array<{
        dealId: number
        level: string | number
        approversByLevel: Array<{
          roleTitle: string | null
          decisionReasonCode: string | null
        }>
        productDetails: Array<{
          lineNumber: number
          itemNumber: number | null
          scaleId: number | null
          netMarginPercentage: number
          totalDiscountPercentage: number
          bdNet: number
          bdNetInDealCurrency: number
        }>
        productlineDetails: Array<{
          productLineCode: string
          netMarginPercentage: number
          estimatedDiscountPercentage: number
          netRevenue: number
        }>
      }>
    } | null
    totalBdNetPriceAmount: number
    totalEstimatedQuantity: number
  }
}
